import {API_REQUEST} from "Request/API";
import {SOURCE_ID_MAP} from "./handleCardRequest";

export const handleAddCardRequest = async (
    toast: any,
    isPrimary: boolean = false,
    paymentMethod: any
) => {

  console.log("paymentMethod?.method",paymentMethod?.method)
  await API_REQUEST("POST", "medical/bank/saveCard", {
    sourceId: paymentMethod?.method ? SOURCE_ID_MAP[paymentMethod?.method] : 1,
    isPrimary: isPrimary,
  })
      .then((res) => (document.location = res?.redirectUrl))
      .catch(() =>
          toast("მოხდა შეცდომა, თავიდან სცადეთ", {
            type: "error",
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            theme: "light",
          })
      );
}